module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h1', {
    staticClass: "chapter-number---IVP sigil_not_in_toc",
    attrs: {
      "id": "_idParaDest-10"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor078"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor079"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor080"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor081"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor082"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor083"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor084"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor085"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page11",
      "title": "11"
    }
  }), _vm._v("1")]), _vm._v(" "), _c('h2', {
    staticClass: "chapter-title---IVP",
    attrs: {
      "id": "_idParaDest-11",
      "title": "1 Five Images of Christ in the Postapostolic Age"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor086"
    }
  }), _vm._v("Five Images of Christ in the Postapostolic Age")]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "dingbat",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/5127_graphic_CH_C.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "veryfirst"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("A")]), _vm._v("s long as the apostles were alive, they were the ultimate authorities in the church, primarily because they had been disciples of Jesus, or in the case of Paul, they could at least claim to have been commissioned and sent by Jesus himself (Gal 1:1; cf. Acts 9:1-19). The apostles, along with their own disciples, were the world’s leading experts on who Jesus was because they had known him personally or because they were there in Jerusalem when the Holy Spirit proceeded to the church on Pentecost. And when they wrote the documents that became the New Testament, they were (and still are) believed to have been inspired by God. According to tradition, John lived the longest, living into the early second century. But by the late first century, any apostles still alive functioned like bishops with itinerant ministries of oversight and regional authority. This means that the beginning of the “postapostolic age” (the age right after the apostles) began at different times in different places."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-020-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" In Rome it had begun after the deaths of Peter and Paul in the mid-60s of the first century. In Asia Minor it did not begin until the death of John.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Therefore, while admitting that there is no clear or uniform beginning to the postapostolic age, we can still define it as the earliest time in the church’s history when there were no living apostles to give "), _c('a', {
    attrs: {
      "id": "_idTextAnchor087"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor088"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor089"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor090"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor091"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor092"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor093"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor094"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page12",
      "title": "12"
    }
  }), _vm._v("a definitive answer to the question that Jesus had asked: “Who do you say that I am?” (Mt 16:13-18). Human nature being what it is, the emergence of the postapostolic age meant that it was probably inevitable that there would be disagreements among the remaining Christians over even the most important aspects of Christian belief.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Although they had the New Testament writings, the church was still coming to a consensus on which of the early documents would be included in the canon."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-019-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" This means that certain teachers or factions within the church could gain followers by ignoring or excluding those books of our Bible with which they did not agree. Some even edited the documents, cutting whole sections out of individual documents, including the Gospels. And even when there was agreement on the acceptance and authority of a particular text, there was often disagreement on the interpretation of that text—a phenomenon that continues to this day, as anyone who has ever had an argument over theology knows. In other words, two people can be reading the same passage of Scripture and understand its message differently. For example, what did Paul mean when he wrote to the Christians in Colossae that Christ was “the firstborn of all creation” (Col 1:15)?"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-018-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" Did he mean that Christ was the first created being? Or that Christ was the agent of creation, as we read in the first chapter of John’s Gospel? Questions like these led to disagreements about the person of Christ in the early church. These disagreements can be categorized as five distinct views of who Jesus Christ was and is.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }, [_vm._v("The Aim and Scope of This Book")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("“Christology” is the name we give to what we believe about Christ. It includes beliefs about his personhood, his nature (divine? human? both?) and in what way he is a Savior or mediator between humanity and the divine. In an apocryphal document known as the "), _c('i', [_vm._v("Apocalypse of Adam")]), _vm._v(", there is a description of thirteen kingdoms, which are allegories for thirteen different theories of who the Savior is—thirteen "), _c('a', {
    attrs: {
      "id": "_idTextAnchor095"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor096"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor097"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor098"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor099"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor100"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor101"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor102"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page13",
      "title": "13"
    }
  }), _vm._v("christologies."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-017-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" The point that the author of this document was making is that all thirteen theories were wrong and only the fringe group that produced the document had the right answer. But the truth is that most of these christologies are variations of the same few or misunder­standings of the beliefs of other factions within, or on the edges of, the church. There were, in reality, five main christologies in the postapostolic age.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Most studies of early heresies, especially gnosticism, focus much of their attention on their speculative cosmologies, that is, their elaborate systems of many deities and angelic beings inhabiting ever-increasing numbers of “layers” within the heavens. The teachings of the excommunicated heretics are then described as salad-bar composites of paganism and astrology with elements of Christianity. This is because the primary sources that are available to us describe them that way, and there is no good reason to believe that their descriptions are not accurate. However, the early Christian writers who describe the heresies focus so much on the speculative and superstitious nature of their paganized version of Christianity (or their Christianized version of paganism) that they often don’t tell us a lot about what they believed "), _c('i', [_vm._v("about Christ")]), _vm._v(" specifically. This book will set aside the cosmologies, and even the theologies (whether they were polytheistic, for example), of the early factions within the church and focus on their christologies—drawing out what they believed about the person of Jesus Christ, as far as we can know. Then we will address the relationship of christology with soteriology (salvation) and also its relation to lifestyle."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-016-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We will limit our study to the postapostolic age, which for our purposes means primarily the second century, though with some overlap into the first century. And because we will not venture very far into the third century, I am not including modalism (“modalistic monarchianism”) among the early views of Christ in the subapostolic age. "), _c('a', {
    attrs: {
      "id": "_idTextAnchor103"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor104"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor105"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor106"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor107"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor108"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page14",
      "title": "14"
    }
  }), _vm._v("Modalism is more a phenomenon of the third century, and it is also technically more of a trinitarian heresy than a christological one."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-015-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" However, I will address it briefly in the concluding chapter in a section on the later legacies of the early christologies.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Before going on, a word on the concept of heresy is in order. The terms "), _c('i', [_vm._v("heresy")]), _vm._v(" and "), _c('i', [_vm._v("heretic")]), _vm._v(" come from a Greek word that implies a faction—a person or group that departs from the majority or the accepted norm. Therefore, by definition, the heresies are those views of Christ that deviated from, and opposed, the view of the “mainstream” or majority of the church. It is true that often in the course of history it is only after a debate is settled or an ecumenical council is held that the heresy can be defined in contrast to the approved interpretation. It is also true that the interpretation of the majority of church leaders is usually the one that wins the day. However, this is not the same thing as simply saying that the story is written by the winners. There was a “mainstream” or majority church in every generation, and the heresies were those teachings that moved far enough away from the mainstream to catch the attention of the ecclesiastical authorities and generate a debate. We also have to remember that "), _c('i', [_vm._v("all")]), _vm._v(" of Christianity was an illegal, persecuted religion in the postapostolic age, so this is not a time when imperial power was used to discriminate against heretics, nor was it a time when heretics were executed for their teachings. That did not happen for another thousand years.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Having said that, I will use the terms "), _c('i', [_vm._v("heresy")]), _vm._v(" and "), _c('i', [_vm._v("heretic")]), _vm._v(" as little as possible in recognition of the fact that the “heretics” were probably sincere believers who thought souls would be at stake if their opponents won the day. And this is precisely what all of the proponents of every christology believed. They could not take a “live and let live” approach to christology because they all believed that the wrong christology would not save its believers.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("We have to keep in mind that all five of these approaches to the person of Jesus Christ were options "), _c('i', [_vm._v("within the church")]), _vm._v(" in the post­apostolic age. Even those that deviated from the majority were still "), _c('a', {
    attrs: {
      "id": "_idTextAnchor109"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor110"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor111"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor112"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor113"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor114"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor115"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor116"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor117"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor118"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor119"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor120"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page15",
      "title": "15"
    }
  }), _vm._v("within the church. If they were not, they would have been considered completely different religions rather than heresies. In any case, we can assume that people with different christologies worshiped together in the house churches of the late first and second centuries. And although there were certainly some “heretics,” teachers of alternative christologies, who gained a following and created their own factions, the existence of different christologies does not necessarily point to completely separate communities."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-014-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" In other words, we should not imagine these five christologies as representing five different “denominations” within Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In most cases, the alternative christologies probably grew up rather organically or around certain early teachers (whom we will meet below). At some time they attracted attention and sparked debate within the church, and if there was a faction leader, that person often got excommunicated by the bishop of the area in question. At some point, the factions made more of a separation from the mainstream and became, in effect, a separate sect. We may remember the words of John when he wrote, “They went out from us, but they did not belong to us; for if they had belonged to us, they would have remained with us” (1 Jn 2:19). When a faction moves far enough from the mainstream, it either leaves the church voluntarily or is kicked out—either way, it has gone beyond the boundary of what is considered acceptable by the majority, and therefore, by definition, it has left the church. This was especially the case with gnosticism as its syncretism moved it farther from Christianity until it finally became something other than Christian.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_3"
    }
  }, [_vm._v("The Dilemma")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The experience of the New Testament church, seeing the miracles of Jesus (and apostles who healed in his name) and especially seeing him after his resurrection, led to the worship of Jesus right from the beginning. Jesus was considered divine. However, the Gospels clearly attest to his humanity. He was born as a baby, grew up, felt emotions, "), _c('a', {
    attrs: {
      "id": "_idTextAnchor121"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor122"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor123"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor124"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor125"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor126"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor127"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor128"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor129"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page16",
      "title": "16"
    }
  }), _vm._v("suffered and died. This means that when it came to defining what Christians believed about the person of Christ, those who wanted to emphasize his divinity had to at least address his apparent humanity, not to mention his suffering and death (even if to deny it), and those who wanted to emphasize his humanity had to address his apparent divinity and his unique relationship with God (again, even if only to deny it).")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("There were good reasons for being on both sides of this dilemma. Those who wanted to emphasize his humanity saw him as one of us and realized that if he were not one of us then it might mean that following his example was really impossible. Those who wanted to emphasize his divinity believed that people cannot follow his example perfectly enough to reconcile themselves to God and that salvation requires divine intervention.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Both sides—in fact every one of the five views of Christ—could agree that what humanity needs is a mediator to reconcile humanity and the divine and that Christ is that mediator. But they disagreed on exactly what it meant for Christ to be a mediator and how he would reconcile. This is in fact what creates the five views—five different ways of understanding how Christ is (or relates to) humanity and divinity.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_4"
    }
  }, [_vm._v("Different Philosophical Assumptions")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("Part of what drives the five different answers to the question, “Who do you say that I am?” is that the different answers begin with different assumptions about what divinity is. If we were to ask the question, “Must divinity be uncreated?” a person of the Hebrew faith would say yes—but a first- or second-century pagan would say not necessarily."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-013-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" In other words, for a Jewish believer, being eternal and uncreated is part of the very definition of divinity. But in the Greco-Roman pantheon, gods who are not eternal can come into being, often as the result of the procreation of older gods. Thus when we examine some of the alternative views of Christ, he can be both divine and created in the sense that he is the “child” of a pair of deities who “gave birth” to his existence.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor130"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor131"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor132"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor133"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor134"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor135"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor136"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page17",
      "title": "17"
    }
  }), _vm._v("On the other hand, if we were to ask whether there could be degrees of divinity, the Hebrew would say no, but the pagan would say yes."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-012-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" For the Jewish believer, a being is either divine or not; there can be no degrees. If a being is created, that being is not divine. If a being is uncreated, that being is divine, and there is only one of those: God. Therefore, for some of the early views of Christ, the fact that he is a mediator between God and humanity means that he cannot be divine because divinity is a status reserved for the Father alone. But for the pagan believer, there is a hierarchy of divinity, sometimes even including the top of the human social ladder, royalty. The point is that for two of the five views of Christ, he can be “quasi-divine,” that is, less divine than the highest god(s) but more divine than the lowest ones.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("If we were to ask, must divinity be immutable and impassible? the Jewish believer would say that these attributes are also part of the very definition of divinity; that is, divinity is unchanging, and divinity cannot suffer. But a pagan would probably agree with the Jews on this one. Apart from the idea that a god can come into being from non­existence (which is, after all, a form of change), many pagans would have agreed that a divine being cannot suffer, and so the combination of a human Christ who suffers and dies with a divine Christ who works miracles and teaches truths is a contradiction that is very difficult to overcome. As St. Paul said, “Christ crucified” is “a stumbling block to Jews and foolishness to Gentiles” (1 Cor 1:23). As we will see, the alternative views of Jesus Christ emerged in part to protect the immutability and impassibility of the divine against beliefs in a suffering deity.")]), _vm._v(" "), _c('h4', {
    staticClass: "subhead-level-1---IVP",
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("The Five Views")]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_vm._v("The chart at the end of this book titled “Christology Continuum” shows the five views of Christ in the postapostolic age. On one side you will see two forms of adoptionism, Spirit Adoptionism (Christ as prophet) and Angel Adoptionism (Christ as angel)."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-011-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" Both of these "), _c('a', {
    attrs: {
      "id": "_idTextAnchor137"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor138"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor139"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor140"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor141"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor142"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor143"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor144"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor145"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor146"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor147"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page18",
      "title": "18"
    }
  }), _vm._v("emphasized the humanity of Christ and diminished or denied his divinity. In other words, they protected the immutability and impassibility of the divine by denying that Jesus is divine—thus his humanity and his suffering do not encroach on the assumed attributes of divinity: a deity must be unchanging and incapable of suffering.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("On the other side you will see two forms of gnosticism, Docetic Gnosticism (Christ as phantom) and Hybrid Gnosticism (Christ as cosmic mind)."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-010-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" Both of these emphasized the divinity of Christ and diminished or denied his humanity. In other words, they protect the immutability and impassibility of the divine by denying that Christ was really human—thus his humanity and his suffering were reduced to an illusion.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In the middle is Logos Christology, the view of the mainstream church, reflecting the teaching of the majority of bishops and theologians. This is the christology that will win out over the others in the debates and councils of the early church, but this is because the majority believed that it is the theology that most faithfully reflected the teachings of the apostles. As we will see, Logos Christology did not deny or diminish either the divinity or the humanity of Jesus Christ but maintained that it was possible (though admittedly paradoxical) to believe in a suffering Savior (Is 53).")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Therefore, from the start we acknowledge that of the five early views of Christ, one was considered “orthodox,” or correct, and four were (eventually) considered heretical, or incorrect. But we also have to acknowledge that it is difficult to speak about “what the heretics believed,” since the actual teachings of those who promoted alternative christologies is often only known to us as reported by their opponents. This is not to say that mainstream bishops and theologians were not accurate when they reported the teachings of their enemies. As far as we know, the reports of theologians like Irenaeus of Lyons and Hippolytus are fairly accurate, if not sympathetic. But we can’t be sure they "), _c('a', {
    attrs: {
      "id": "_idTextAnchor148"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor149"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor150"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor151"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor152"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor153"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor154"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor155"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page19",
      "title": "19"
    }
  }), _vm._v("give us the whole picture, so we have to tread lightly and try not to make too many assumptions or arguments from silence.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In addition, all five christologies developed over time, as each generation of teachers built on the legacies of their own teachers and others who came before them. So just as the mainstream view came to be increasingly clarified over the years, so the alternative christologies also developed, and all did so in dialogue and debate with each other. I have written elsewhere that “heresy forces orthodoxy to define itself.”"), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-009-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" This is certainly true, but it is also true that orthodoxy forced the alternative christologies to define and further clarify themselves as well. Therefore, it must be admitted that the present study can provide an overview of the five christologies but cannot illuminate the individual beliefs of every version of Christianity in the postapostolic age. Although we boil the options down to five, I do not mean to imply that these are neatly distinct pigeonholes. Rather, they are points on a spectrum, and we can probably assume that there was as much diversity of belief within these factions as there was between them. So we are looking at a continuum of belief, and the five views described in the following chapters are at the same time both generalizations and a helpful way to come to understand what different people believed about Jesus Christ.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("When it comes to the two forms of gnosticism, we do have some documents that appear to come from the gnostics themselves, and so we are not entirely limited to relying on their enemies to understand their beliefs. The largest collection of gnostic texts is the Nag Hammadi Library, which is available in English translation."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-008-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" This is a very valuable collection of documents, and it includes some of the most famous gnostic texts, such as the Gospel of Thomas and the Gospel of Philip."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-007-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" However, the versions of the documents that we have are late, probably fourth century, and therefore they are not necessarily a faithful representa­tion of anyone’s actual beliefs in the second century. In fact, if the fragments "), _c('a', {
    attrs: {
      "id": "_idTextAnchor156"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor157"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor158"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor159"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor160"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor161"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor162"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor163"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor164"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page20",
      "title": "20"
    }
  }), _vm._v("of Plato’s "), _c('i', [_vm._v("Republic")]), _vm._v(" that were found with these documents are any indication, we cannot rely on these texts for accuracy of transmission or translation."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-006-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" Furthermore, the documents of the Nag Hammadi Library were collected by one group of Christians in the fourth century, and the beliefs of that group (whatever they were) would determine which documents were preserved and whether they were edited to conform to the beliefs of the group. Finally, most of the material in these documents is not about christology per se, and so the christology has to be gleaned from wherever it pops up—and in fact many of the Nag Hammadi documents are not helpful at all in revealing the christology of the group that may be responsible for the document. Most of the gnostic writings tend to be postresurrection conversations with Christ that are really just a lot of supposed sayings of Christ strung together."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-005-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" They tell us what they believed he said but not as much about what they believed he "), _c('i', [_vm._v("was")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("All of this has led several scholars to question the very concept of “gnosticism” in favor of recognizing that there were many forms of gnosticism. Michael Williams and Karen King want to discontinue using the term "), _c('i', [_vm._v("gnosticism")]), _vm._v(" altogether."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-004-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" But this is counterproductive, since it would leave us with no alternative but to divide gnosticism into individual schools, a method that led Irenaeus and Hippolytus to write their almost unmanageably long treatises on the heresies."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-003-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" I would argue that it is much more productive to categorize the many schools of gnosticism by their christology, which leaves us with two distinct versions of gnostic belief."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-002-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" The third-century theologian Novatian recognized this when he wrote,")]), _vm._v(" "), _c('p', {
    staticClass: "blockfirst"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor165"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor166"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor167"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor168"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor169"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor170"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor171"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor172"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor173"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor174"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor175"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor176"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor177"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page21",
      "title": "21"
    }
  }), _vm._v("And so we do not acknowledge the christ of these heretics, who is said to have existed in appearance but not in reality, for there is nothing real of those things which he has supposedly done, if he himself was a phantom and not real. We do not acknowledge one who has carried in himself nothing of our body, received nothing from Mary, and has not really even come to us, since he appeared without our human nature.")]), _vm._v(" "), _c('p', {
    staticClass: "blocklast"
  }, [_vm._v("Nor do we acknowledge one who has put on ethereal or other-worldly flesh, as other heretics have supposed, for we could not realize our salvation in him if we could not recognize our solid body in him. Nor do we acknowledge any other christ at all, who carries any other kind of mythical body from the fabrication of heretics."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The first paragraph in the quotation above is directed at docetism and Docetic Gnosticism (Christ as phantom), and the second paragraph is directed at Hybrid Gnosticism (Christ as cosmic mind). Furthermore, I will argue that the two different kinds of gnosticism led to two different lifestyles because their christologies inform their anthropologies (their understanding of what it means to be human) to such an extent that it drove how they behaved and how they treated others.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("On the other side of the spectrum, Origen saw two kinds of “Jewish Christianity” (adoptionism)."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-000-backlink"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#footnote-000",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" In one, Jesus was a mere human, which is analogous to the category I am calling Spirit Adoptionism (Christ as prophet), and in the other, Jesus, or the spiritual entity that indwelt him, had some kind of preexistence. This is analogous to the category I am calling Angel Adoptionism (Christ as angel).")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("The heresies, or alternative christologies, come first in the following chapters, not because they came first historically, but because orthodoxy was clarified in response to them. So we will explore the two kinds of adoptionism in the next two chapters, then the two kinds of gnosticism, and then the christology of the mainstream.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Finally, it is important to note at the outset that of the five christologies, four of them will solve the problem of the paradox of a "), _c('a', {
    attrs: {
      "id": "_idTextAnchor178"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor179"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor180"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor181"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor182"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor183"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor184"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor185"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor186"
    }
  }), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page22",
      "title": "22"
    }
  }), _vm._v("suffering Savior by making a radical separation between Jesus and “the Christ,” as if they are two different entities (or in one case, as if the former never really existed). Only the Logos Christology of the mainstream church will affirm the unity of Jesus Christ and, even when speaking of the two natures, will refuse to label the humanity “Jesus” and the divinity “Christ.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30f8589c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch1.vue
// module id = 69
// module chunks = 0